// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2or4T","footer":"ReportModalFilter_footer__3vNbY"};